import { asyncDerived } from '@square/svelte-store';
import { region, type Region } from './region';
import { browser } from '$app/environment';
import type { GetCartQuery } from '$gql/storefront/operations';
import { writable } from 'svelte/store';

const SESSION_KEY = '__hey-harper_nosto_session__';

const slotIds = {
  us: {
    productPage: 'productpage-nosto-reco-cross-sell',
    cartPage: 'cartpage-nosto-4'
  },
  uk: {
    productPage: 'productpage-nosto-reco-cross-sell-copy',
    cartPage: 'cartpage-nosto-4'
  },
  eu: {
    productPage: 'productpage-nosto-also-like',
    cartPage: 'cartpage-nosto-4'
  }
};

export const nostoSession = asyncDerived([region], async ([$region]) => {
  if (browser) {
    const sessionToken = sessionStorage.getItem(SESSION_KEY)?.replace(/"/g, '');

    if (sessionToken) {
      return sessionToken;
    }

    const req = await fetch('/api/nosto', {
      method: 'POST',
      body: JSON.stringify({ region: $region || 'us' })
    });

    const newToken = await req.json();

    sessionStorage.setItem(SESSION_KEY, JSON.stringify(newToken));

    return newToken;
  }
});

export const sendNostoEvent = async ({
  type,
  nostoSession,
  target,
  category,
  user,
  cart,
  region,
  slotId
}: {
  type: string;
  nostoSession: string;
  target: string;
  category?: string;
  cart?: GetCartQuery['cart'];
  user?: {
    firstName?: string;
    lastName?: string;
    customerReference?: string;
  };
  region: Region;
  slotId?: string;
}) => {
  if (!target || !nostoSession) return;

  const pagesSlotId = slotId ? { productPage: slotId, cartPage: slotId } : slotIds[region];

  const request = await fetch('/api/nosto/send-event', {
    method: 'POST',
    body: JSON.stringify({
      type,
      nostoSession,
      target,
      category,
      cart,
      user,
      region,
      slotIds: pagesSlotId
    })
  });

  return await request.json();
};

export const getNostoRecomendations = async ({
  productsId,
  region,
  slotId
}: {
  productsId: string[];
  region: Region;
  slotId?: string;
}) => {
  const request = await fetch('/api/nosto/get-recommendations', {
    method: 'POST',
    body: JSON.stringify({
      productsId,
      region,
      slotId
    })
  });

  const response = await request.json();

  return response;
};

export const nostoRecommendations = writable<Array<{ productId: string }> | []>([]);
